import createLucideIcon from '../createLucideIcon';

const SeparatorVertical = createLucideIcon('SeparatorVerticalIcon', [
  ['line', { x1: '12', y1: '3', x2: '12', y2: '21', key: 'essbwb' }],
  ['polyline', { points: '8 8 4 12 8 16', key: 'bnfmv4' }],
  ['polyline', { points: '16 16 20 12 16 8', key: 'u90052' }],
]);

export default SeparatorVertical;
